/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedStarterPacksSkeleton.defs.js'
export * as $defs from './getSuggestedStarterPacksSkeleton.defs.js'
